import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, Router } from "@angular/router";
import { JwtHelperService } from "@auth0/angular-jwt";
import { AuthenticationService } from "../share-modul/services/authentication/authentication.service";
import { RoleNameEnum } from "../admin-panel/enums/role-name.enum";
import { VenueService } from "src/api/generated/services";
import { GetDefaultCurrency_1$Params } from "src/api/generated/fn/venue/get-default-currency-1";
const _jwtHelper = new JwtHelperService();
const TOKEN_KEY = 'pos_access_token';
const REFRESH_TOKEN_KEY = 'refresh_token';
const WAITER_TOKEN_KEY = 'waiter_access_token';
const WAITER_REFRESH_TOKEN_KEY = 'waiter_refresh_token';

@Injectable()

export class AuthGuard implements CanActivate {

    private tokenKey: string;
    private waiterTokenKey: string;


    constructor(private _router: Router , private authenticationService : AuthenticationService, private venueService: VenueService) {
    }

    canActivate(route: ActivatedRouteSnapshot) {
      this.tokenKey = window.localStorage.getItem(TOKEN_KEY) as string;
      this.waiterTokenKey = window.localStorage.getItem(WAITER_TOKEN_KEY) as string;

      if (this.tokenKey != null && !_jwtHelper.isTokenExpired(this.tokenKey)) {

        if(route.routeConfig?.path?.match('page-not-found')) {
          return true;
        }

        this.authenticationService._isManager$.next(_jwtHelper.decodeToken(this.tokenKey).rlnm.includes(RoleNameEnum.PosManager));
        this.authenticationService._isAdmin$.next(_jwtHelper.decodeToken(this.tokenKey).rlnm.includes(RoleNameEnum.PosGeneralManager));

        if(route.data?.isWaiterRoute == true){
          this._router.navigate(['/page-not-found']);
        }
        
        if (_jwtHelper.decodeToken(this.tokenKey).rlnm.includes(RoleNameEnum.PosManager) && this.waiterTokenKey == null) {
          if(route.data?.isWaiterRoute == true){
            this._router.navigate(['/dashboard']);
          }
        }

        return true;

      } else if (this.waiterTokenKey != null && !_jwtHelper.isTokenExpired(this.waiterTokenKey)) {
        if (_jwtHelper.decodeToken(this.waiterTokenKey).rlnm.includes(RoleNameEnum.Waiter)) {
          if(route.data?.isWaiterRoute == undefined){
            this._router.navigate(['/page-not-found']);
            return false;
          }
        }
        return true;
      } else {
        this.authenticationService.loginUser.next(null);
        this.authenticationService._isLoggedIn$.next(false);
        this.authenticationService._isManager$.next(false);
        this.authenticationService._isAdmin$.next(false);
        localStorage.removeItem(TOKEN_KEY);
        localStorage.removeItem(REFRESH_TOKEN_KEY);
        localStorage.removeItem(WAITER_TOKEN_KEY);
        localStorage.removeItem(WAITER_REFRESH_TOKEN_KEY);
        this._router.navigate(['login']);
        return false;
      }

    }

  }
